import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const sectionContainerStyles = {
    padding: {base: `0 ${pxToRem(7)}`, md: `0 ${pxToRem(21)}`},
    h2: {
        textAlign: 'center',
        fontSize: {base: pxToRem(18), md: pxToRem(40)},
        lineHeight: {base: pxToRem(21.6), md: pxToRem(48)},
        marginTop: pxToRem(40),
        marginBottom: {base: pxToRem(50), md: pxToRem(30)},
        textTransform: 'uppercase',
        fontFamily: fonts.primary,
        color: 'cav_light_black',
        fontWeight: 700,
        letterSpacing: {base: pxToRem(4.68), md: pxToRem(10.5)}
    }
}

export const linkTextStyles = {
    p: {
        fontSize: pxToRem(14),
        fontWeight: 700,
        height: pxToRem(18),
        letterSpacing: pxToRem(1),
        lineHeight: pxToRem(18),
        marginTop: pxToRem(30),
        marginBottom: {base: pxToRem(40), md: 0},
        fontFamily: fonts.primary
    },
    _hover: {
        color: 'cav_red',
        textDecoration: 'none'
    }
}

export const contentContainerStyles = {
    '.html-slot-container': {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        boxSizing: 'border-box',
        overflowX: 'hidden'
    },
    '.calloutAdditionalWrapper': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        margin: '15px 0px',
        flexWrap: {base: 'nowrap', md: 'wrap'}
    },
    '.calloutMsg': {
        fontSize: {base: pxToRem(18), md: pxToRem(22)},
        textTransform: 'uppercase',
        fontFamily: fonts.primary,
        color: 'black',
        fontWeight: 700,
        letterSpacing: pxToRem(3),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: 1,
        minWidth: 0
    },
    '.additionalContent': {
        fontSize: pxToRem(12),
        fontFamily: fonts.primary,
        fontWeight: 500,
        lineHeight: pxToRem(21),
        letterSpacing: pxToRem(1),
        color: 'cav_red',
        textDecoration: 'underline',
        cursor: 'pointer',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        marginLeft: pxToRem(10)
    },
    // Icons Styles(FF2)
    '.icon-carousel-wrapper': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    '.icon-carousel-arrow': {
        position: 'absolute',
        display: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        width: {base: pxToRem(30), md: pxToRem(40)},
        height: {base: pxToRem(30), md: pxToRem(40)},
        borderRadius: '50%',
        border: 'none',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        zIndex: 10,
        '&:hover': {
            backgroundColor: 'white'
        },
        svg: {
            width: {base: pxToRem(30), md: pxToRem(40)},
            height: {base: pxToRem(30), md: pxToRem(40)},
            color: 'white',
            '&:hover': {
                color: 'black'
            }
        }
    },
    '.carousel-arrow-left': {
        left: pxToRem(10)
    },
    '.carousel-arrow-right': {
        right: pxToRem(10)
    },
    '.icon-category-navigation': {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: {base: 'flex-start', md: 'center'},
        gap: {base: pxToRem(37), lg: pxToRem(70), xl: pxToRem(100)},
        overflowX: 'auto',
        scrollBehavior: 'smooth',
        flex: 1,
        padding: `0 ${pxToRem(10)}`,
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none'
    },
    '.icon-nav-item': {
        textAlign: 'center',
        flexShrink: 0,
        a: {
            textDecoration: 'none',
            color: '#000',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: pxToRem(8)
        },
        _hover: {
            '.nav-label': {
                textDecoration: 'underline'
            }
        }
    },
    '.icon-nav-icon': {
        img: {
            maxW: pxToRem(50),
            maxH: pxToRem(50),
            objectFit: 'contain'
        }
    },
    '.icon-nav-label': {
        fontSize: pxToRem(14),
        fontWeight: 700,
        fontStyle: fonts.primary,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        color: 'black',
        letterSpacing: pxToRem(1.5)
    },
    'ul.custom-category-list': {
        display: 'flex',
        flexWrap: 'wrap',
        p: 0,
        m: 0,
        justifyContent: 'space-between',
        'li.custom-category-item': {
            listStyle: 'none',
            textAlign: 'center',
            width: {base: '46%', md: '23%'},
            boxSizing: 'border-box'
        }
    },
    'ul.custom-category-list h3.custom-category-title': {
        fontSize: {base: pxToRem(12), lg: pxToRem(14)},
        fontWeight: 700,
        letterSpacing: pxToRem(1),
        mt: {base: pxToRem(16), md: pxToRem(15)},
        mb: {base: pxToRem(10), md: 0},
        fontFamily: fonts.primary,
        textTransform: 'uppercase',
        a: {
            color: 'black',
            _hover: {
                color: 'cav_red',
                textDecoration: 'none'
            }
        }
    },
    '.shop-button': {
        width: '90%',
        backgroundColor: 'cav_red',
        border: 'none',
        py: pxToRem(8),
        marginTop: pxToRem(-8),
        cursor: 'pointer',
        fontWeight: 700,
        color: 'white !important',
        display: 'inline-block',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: {base: pxToRem(12), lg: pxToRem(14)},
        letterSpacing: pxToRem(1),
        '&:hover': {
            backgroundColor: 'white',
            border: `${pxToRem(1)} solid #AE132A`,
            color: 'cav_red !important'
        }
    },
    '.shop-button a': {
        color: 'white',
        textDecoration: 'none',
        display: 'block'
    },
    // Shop By Brand Styles(FF5)
    '.shop-by-brand-carousel-wrapper': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    '.shop-by-brand-carousel-arrow': {
        position: 'absolute',
        display: 'none',
        alignItems: 'center',
        justifyContent: 'center',
        width: {base: pxToRem(30), md: pxToRem(40)},
        height: {base: pxToRem(30), md: pxToRem(40)},
        borderRadius: '50%',
        border: 'none',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        zIndex: 10,
        '&:hover': {
            backgroundColor: 'white',
            svg: {
                color: 'black'
            }
        },
        svg: {
            width: {base: pxToRem(20), md: pxToRem(24)},
            height: {base: pxToRem(20), md: pxToRem(24)},
            color: 'white'
        }
    },
    '.shop-by-brand-carousel': {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: {base: pxToRem(15), md: pxToRem(25)},
        p: 0,
        m: 0,
        overflowX: 'auto',
        scrollBehavior: 'smooth',
        flex: 1,
        listStyle: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        li: {
            listStyle: 'none',
            textAlign: 'center',
            width: '100%',
            flexShrink: 0,
            boxSizing: 'border-box',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)}
        }
    },
    '.shop-by-brand-sale-title-style4, .shop-by-brand-sale-description-style4, .shop-by-brand-sale-button-container-style4, .shop-by-brand-sale-button-style4, .shop-by-brand-sale-button-container-style3, .shop-by-brand-sale-button-style3':
        {
            display: 'none'
        },
    '.shop-by-brand-style1': {
        '.shop-by-brand-image-wrapper-style1': {
            position: 'relative',
            width: '100%',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)},
            display: 'inline-block'
        },
        '.shop-by-brand-main-image-style1': {
            width: '100%',
            display: 'block',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)},
            height: {base: pxToRem(225), md: pxToRem(300), xl: pxToRem(443)},
            objectFit: 'cover'
        },
        '.shop-by-brand-overlay-image-style1': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '55%',
            maxHeight: '55%',
            objectFit: 'contain'
        },
        '.shop-by-brand-sale-button-container-style1': {
            fontSize: {base: pxToRem(12), md: pxToRem(14)},
            m: 0,
            mt: pxToRem(10),
            fontWeight: 700,
            letterSpacing: pxToRem(1.5),
            fontFamily: fonts.primary,
            textTransform: 'uppercase',
            '.shop-by-brand-sale-button-style1': {
                color: 'black',
                _hover: {
                    color: 'cav_red',
                    textDecoration: 'none'
                }
            }
        }
    },
    '.shop-by-brand-style2': {
        '.shop-by-brand-image-wrapper-style2': {
            position: 'relative',
            width: '100%',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)},
            display: 'inline-block'
        },
        '.shop-by-brand-main-image-style2': {
            width: '100%',
            display: 'block',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)},
            height: {base: pxToRem(225), md: pxToRem(300), xl: pxToRem(443)},
            objectFit: 'cover'
        },
        '.shop-by-brand-overlay-image-style2': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '55%',
            maxHeight: '55%',
            objectFit: 'contain'
        },
        '.shop-by-brand-sale-title-style2': {
            fontSize: {base: pxToRem(14), md: pxToRem(16)},
            fontWeight: 600,
            letterSpacing: pxToRem(2),
            fontFamily: fonts.primary,
            lineHeight: '100%',
            textTransform: 'uppercase',
            color: 'black',
            my: pxToRem(10)
        },
        '.shop-by-brand-sale-description-style2': {
            fontSize: {base: pxToRem(12), md: pxToRem(16)},
            fontWeight: 400,
            letterSpacing: pxToRem(1),
            fontFamily: fonts.primary,
            color: 'black',
            mb: pxToRem(10)
        },
        '.shop-by-brand-sale-button-container-style2': {
            fontSize: {base: pxToRem(12), md: pxToRem(14)},
            m: 0,
            fontWeight: 700,
            letterSpacing: pxToRem(1.5),
            fontFamily: fonts.primary,
            textTransform: 'uppercase',
            '.shop-by-brand-sale-button-style2': {
                color: 'black',
                _hover: {
                    color: 'cav_red',
                    textDecoration: 'none'
                }
            }
        }
    },
    '.shop-by-brand-style3': {
        '.shop-by-brand-image-wrapper-style3': {
            position: 'relative',
            width: '100%',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)},
            display: 'inline-block'
        },
        '.shop-by-brand-main-image-style3': {
            width: '100%',
            display: 'block',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)},
            height: {base: pxToRem(300), md: pxToRem(400), xl: pxToRem(443)},
            objectFit: 'cover'
        },
        '.shop-by-brand-overlay-image-style3': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '55%',
            maxHeight: '55%',
            objectFit: 'contain'
        },
        '.shop-by-brand-sale-button-container-style3': {
            display: 'block',
            position: 'absolute',
            bottom: {base: '5%', md: '5%', xl: '7%'},
            left: '50%',
            transform: 'translateX(-50%)',
            width: '90%',
            fontSize: {base: pxToRem(12), md: pxToRem(14)},
            fontWeight: 700,
            letterSpacing: pxToRem(1.5),
            fontFamily: fonts.primary,
            textTransform: 'uppercase',
            margin: 0,
            textAlign: 'center',
            zIndex: 10,
            '.shop-by-brand-sale-button-style3': {
                display: 'inline-block',
                color: 'white',
                pointerEvents: 'auto',
                _hover: {
                    color: 'cav_red',
                    textDecoration: 'none'
                }
            }
        }
    },
    '.shop-by-brand-style4': {
        '.shop-by-brand-image-wrapper-style4': {
            position: 'relative',
            width: '100%',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)},
            display: 'inline-block'
        },
        '.shop-by-brand-main-image-style4': {
            width: '100%',
            display: 'block',
            maxW: {base: pxToRem(225), md: pxToRem(270), xl: pxToRem(443)},
            height: {base: pxToRem(300), md: pxToRem(400), xl: pxToRem(577)},
            objectFit: 'cover'
        },
        '.shop-by-brand-overlay-image-style4': {
            position: 'absolute',
            top: '10%',
            left: '50%',
            transform: 'translateX(-50%)',
            maxWidth: '45%',
            maxHeight: '30%',
            objectFit: 'contain',
            zIndex: 1
        },
        '.shop-by-brand-sale-title-style4': {
            display: 'block',
            position: 'absolute',
            bottom: {base: '27.5%', md: '25%', xl: '20%'},
            left: '50%',
            transform: 'translateX(-50%)',
            width: '90%',
            fontSize: {base: pxToRem(14), md: pxToRem(16)},
            fontWeight: 600,
            letterSpacing: pxToRem(2),
            fontFamily: fonts.primary,
            textTransform: 'uppercase',
            color: 'white',
            margin: 0,
            textAlign: 'center',
            zIndex: 10,
            pointerEvents: 'none'
        },
        '.shop-by-brand-sale-description-style4': {
            display: 'block',
            position: 'absolute',
            bottom: {base: '14%', md: '13%', xl: '11.5%'},
            left: '50%',
            transform: 'translateX(-50%)',
            width: '90%',
            fontSize: {base: pxToRem(12), md: pxToRem(14)},
            fontWeight: 400,
            letterSpacing: pxToRem(0.5),
            fontFamily: fonts.primary,
            lineHeight: '120%',
            color: 'white',
            margin: 0,
            textAlign: 'center',
            zIndex: 10,
            pointerEvents: 'none'
        },
        '.shop-by-brand-sale-button-style4': {
            display: 'block',
            position: 'absolute',
            bottom: {base: '5%', md: '5%', xl: '5%'},
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            fontSize: {base: pxToRem(12), md: pxToRem(14)},
            fontWeight: 700,
            letterSpacing: pxToRem(1.5),
            fontFamily: fonts.primary,
            textTransform: 'uppercase',
            margin: 0,
            textAlign: 'center',
            zIndex: 10,
            color: 'white',
            pointerEvents: 'auto',
            _hover: {
                color: 'cav_red',
                textDecoration: 'none'
            }
        }
    },
    '.clp-seo-slot': {
        color: 'black',
        p: {
            marginTop: pxToRem(16),
            a: {
                color: 'black',
                textDecoration: 'underline'
            }
        }
    }
}
